export const PROJECT_ON_BOARD_LOAD_LOGIN_PLUGIN_CONFIGURATION_BEGIN =
  'PROJECT_ON_BOARD_LOAD_LOGIN_PLUGIN_CONFIGURATION_BEGIN';
export const PROJECT_ON_BOARD_LOAD_LOGIN_PLUGIN_CONFIGURATION_SUCCESS =
  'PROJECT_ON_BOARD_LOAD_LOGIN_PLUGIN_CONFIGURATION_SUCCESS';
export const PROJECT_ON_BOARD_LOAD_LOGIN_PLUGIN_CONFIGURATION_FAILURE =
  'PROJECT_ON_BOARD_LOAD_LOGIN_PLUGIN_CONFIGURATION_FAILURE';
export const PROJECT_ON_BOARD_LOAD_LOGIN_PLUGIN_CONFIGURATION_DISMISS_ERROR =
  'PROJECT_ON_BOARD_LOAD_LOGIN_PLUGIN_CONFIGURATION_DISMISS_ERROR';
export const PROJECT_ON_BOARD_INSTALL_LOGIN_PLUGIN_BEGIN =
  'PROJECT_ON_BOARD_INSTALL_LOGIN_PLUGIN_BEGIN';
export const PROJECT_ON_BOARD_INSTALL_LOGIN_PLUGIN_SUCCESS =
  'PROJECT_ON_BOARD_INSTALL_LOGIN_PLUGIN_SUCCESS';
export const PROJECT_ON_BOARD_INSTALL_LOGIN_PLUGIN_FAILURE =
  'PROJECT_ON_BOARD_INSTALL_LOGIN_PLUGIN_FAILURE';
export const PROJECT_ON_BOARD_INSTALL_LOGIN_PLUGIN_DISMISS_ERROR =
  'PROJECT_ON_BOARD_INSTALL_LOGIN_PLUGIN_DISMISS_ERROR';
export const PROJECT_ON_BOARD_LOAD_COLLECTION_FOR_PROJECT_ON_BOARD_BEGIN =
  'PROJECT_ON_BOARD_LOAD_COLLECTION_FOR_PROJECT_ON_BOARD_BEGIN';
export const PROJECT_ON_BOARD_LOAD_COLLECTION_FOR_PROJECT_ON_BOARD_SUCCESS =
  'PROJECT_ON_BOARD_LOAD_COLLECTION_FOR_PROJECT_ON_BOARD_SUCCESS';
export const PROJECT_ON_BOARD_LOAD_COLLECTION_FOR_PROJECT_ON_BOARD_FAILURE =
  'PROJECT_ON_BOARD_LOAD_COLLECTION_FOR_PROJECT_ON_BOARD_FAILURE';
export const PROJECT_ON_BOARD_LOAD_COLLECTION_FOR_PROJECT_ON_BOARD_DISMISS_ERROR =
  'PROJECT_ON_BOARD_LOAD_COLLECTION_FOR_PROJECT_ON_BOARD_DISMISS_ERROR';
export const PROJECT_ON_BOARD_LOAD_POPULAR_EXTENSION_BEGIN =
  'PROJECT_ON_BOARD_LOAD_POPULAR_EXTENSION_BEGIN';
export const PROJECT_ON_BOARD_LOAD_POPULAR_EXTENSION_SUCCESS =
  'PROJECT_ON_BOARD_LOAD_POPULAR_EXTENSION_SUCCESS';
export const PROJECT_ON_BOARD_LOAD_POPULAR_EXTENSION_FAILURE =
  'PROJECT_ON_BOARD_LOAD_POPULAR_EXTENSION_FAILURE';
export const PROJECT_ON_BOARD_LOAD_POPULAR_EXTENSION_DISMISS_ERROR =
  'PROJECT_ON_BOARD_LOAD_POPULAR_EXTENSION_DISMISS_ERROR';
export const PROJECT_ON_BOARD_FETCH_PLUGIN_FORM_BEGIN = 'PROJECT_ON_BOARD_FETCH_PLUGIN_FORM_BEGIN';
export const PROJECT_ON_BOARD_FETCH_PLUGIN_FORM_SUCCESS =
  'PROJECT_ON_BOARD_FETCH_PLUGIN_FORM_SUCCESS';
export const PROJECT_ON_BOARD_FETCH_PLUGIN_FORM_FAILURE =
  'PROJECT_ON_BOARD_FETCH_PLUGIN_FORM_FAILURE';
export const PROJECT_ON_BOARD_FETCH_PLUGIN_FORM_DISMISS_ERROR =
  'PROJECT_ON_BOARD_FETCH_PLUGIN_FORM_DISMISS_ERROR';
export const PROJECT_ON_BOARD_CHANGE_PROJECT_STATUS_BEGIN =
  'PROJECT_ON_BOARD_CHANGE_PROJECT_STATUS_BEGIN';
export const PROJECT_ON_BOARD_CHANGE_PROJECT_STATUS_SUCCESS =
  'PROJECT_ON_BOARD_CHANGE_PROJECT_STATUS_SUCCESS';
export const PROJECT_ON_BOARD_CHANGE_PROJECT_STATUS_FAILURE =
  'PROJECT_ON_BOARD_CHANGE_PROJECT_STATUS_FAILURE';
export const PROJECT_ON_BOARD_CHANGE_PROJECT_STATUS_DISMISS_ERROR =
  'PROJECT_ON_BOARD_CHANGE_PROJECT_STATUS_DISMISS_ERROR';
export const PROJECT_ON_BOARD_CREATE_COLLECTION_BEGIN = 'PROJECT_ON_BOARD_CREATE_COLLECTION_BEGIN';
export const PROJECT_ON_BOARD_CREATE_COLLECTION_SUCCESS =
  'PROJECT_ON_BOARD_CREATE_COLLECTION_SUCCESS';
export const PROJECT_ON_BOARD_CREATE_COLLECTION_FAILURE =
  'PROJECT_ON_BOARD_CREATE_COLLECTION_FAILURE';
export const PROJECT_ON_BOARD_CREATE_COLLECTION_DISMISS_ERROR =
  'PROJECT_ON_BOARD_CREATE_COLLECTION_DISMISS_ERROR';
export const PROJECT_ON_BOARD_CREATE_FIELD_BEGIN = 'PROJECT_ON_BOARD_CREATE_FIELD_BEGIN';
export const PROJECT_ON_BOARD_CREATE_FIELD_SUCCESS = 'PROJECT_ON_BOARD_CREATE_FIELD_SUCCESS';
export const PROJECT_ON_BOARD_CREATE_FIELD_DISMISS_ERROR =
  'PROJECT_ON_BOARD_CREATE_FIELD_DISMISS_ERROR';
export const PROJECT_ON_BOARD_CREATE_FIELD_FAILURE = 'PROJECT_ON_BOARD_CREATE_FIELD_FAILURE';
export const PROJECT_ON_BOARD_INSTALL_ADDITIONAL_PLUGIN_BEGIN = 'PROJECT_ON_BOARD_INSTALL_ADDITIONAL_PLUGIN_BEGIN';
export const PROJECT_ON_BOARD_INSTALL_ADDITIONAL_PLUGIN_SUCCESS = 'PROJECT_ON_BOARD_INSTALL_ADDITIONAL_PLUGIN_SUCCESS';
export const PROJECT_ON_BOARD_INSTALL_ADDITIONAL_PLUGIN_FAILURE = 'PROJECT_ON_BOARD_INSTALL_ADDITIONAL_PLUGIN_FAILURE';
export const PROJECT_ON_BOARD_INSTALL_ADDITIONAL_PLUGIN_DISMISS_ERROR = 'PROJECT_ON_BOARD_INSTALL_ADDITIONAL_PLUGIN_DISMISS_ERROR';
export const PROJECT_ON_BOARD_GET_XANO_SCHEMA_BEGIN = 'PROJECT_ON_BOARD_GET_XANO_SCHEMA_BEGIN';
export const PROJECT_ON_BOARD_GET_XANO_SCHEMA_SUCCESS = 'PROJECT_ON_BOARD_GET_XANO_SCHEMA_SUCCESS';
export const PROJECT_ON_BOARD_GET_XANO_SCHEMA_FAILURE = 'PROJECT_ON_BOARD_GET_XANO_SCHEMA_FAILURE';
export const PROJECT_ON_BOARD_GET_XANO_SCHEMA_DISMISS_ERROR = 'PROJECT_ON_BOARD_GET_XANO_SCHEMA_DISMISS_ERROR';
export const PROJECT_ON_BOARD_XANO_PROJECTSLIST_BEGIN = 'PROJECT_ON_BOARD_XANO_PROJECTSLIST_BEGIN';
export const PROJECT_ON_BOARD_XANO_PROJECTSLIST_SUCCESS = 'PROJECT_ON_BOARD_XANO_PROJECTSLIST_SUCCESS';
export const PROJECT_ON_BOARD_XANO_PROJECTSLIST_FAILURE = 'PROJECT_ON_BOARD_XANO_PROJECTSLIST_FAILURE';
export const PROJECT_ON_BOARD_XANO_PROJECTSLIST_DISMISS_ERROR = 'PROJECT_ON_BOARD_XANO_PROJECTSLIST_DISMISS_ERROR';
export const PROJECT_ON_BOARD_XANOCOLLECTION_NAMES_BEGIN = 'PROJECT_ON_BOARD_XANOCOLLECTION_NAMES_BEGIN';
export const PROJECT_ON_BOARD_XANOCOLLECTION_NAMES_SUCCESS = 'PROJECT_ON_BOARD_XANOCOLLECTION_NAMES_SUCCESS';
export const PROJECT_ON_BOARD_XANOCOLLECTION_NAMES_FAILURE = 'PROJECT_ON_BOARD_XANOCOLLECTION_NAMES_FAILURE';
export const PROJECT_ON_BOARD_XANOCOLLECTION_NAMES_DISMISS_ERROR = 'PROJECT_ON_BOARD_XANOCOLLECTION_NAMES_DISMISS_ERROR';
export const PROJECT_ON_BOARD_APISAVE_DATA_CALL_BEGIN = 'PROJECT_ON_BOARD_APISAVE_DATA_CALL_BEGIN';
export const PROJECT_ON_BOARD_APISAVE_DATA_CALL_SUCCESS = 'PROJECT_ON_BOARD_APISAVE_DATA_CALL_SUCCESS';
export const PROJECT_ON_BOARD_APISAVE_DATA_CALL_FAILURE = 'PROJECT_ON_BOARD_APISAVE_DATA_CALL_FAILURE';
export const PROJECT_ON_BOARD_APISAVE_DATA_CALL_DISMISS_ERROR = 'PROJECT_ON_BOARD_APISAVE_DATA_CALL_DISMISS_ERROR';
export const PROJECT_ON_BOARD_APICALL_GET_TBALES_DATA_BEGIN = 'PROJECT_ON_BOARD_APICALL_GET_TBALES_DATA_BEGIN';
export const PROJECT_ON_BOARD_APICALL_GET_TBALES_DATA_SUCCESS = 'PROJECT_ON_BOARD_APICALL_GET_TBALES_DATA_SUCCESS';
export const PROJECT_ON_BOARD_APICALL_GET_TBALES_DATA_FAILURE = 'PROJECT_ON_BOARD_APICALL_GET_TBALES_DATA_FAILURE';
export const PROJECT_ON_BOARD_APICALL_GET_TBALES_DATA_DISMISS_ERROR = 'PROJECT_ON_BOARD_APICALL_GET_TBALES_DATA_DISMISS_ERROR';
export const PROJECT_ON_BOARD_APICALL_TO_ADD_FIELDS_BEGIN = 'PROJECT_ON_BOARD_APICALL_TO_ADD_FIELDS_BEGIN';
export const PROJECT_ON_BOARD_APICALL_TO_ADD_FIELDS_SUCCESS = 'PROJECT_ON_BOARD_APICALL_TO_ADD_FIELDS_SUCCESS';
export const PROJECT_ON_BOARD_APICALL_TO_ADD_FIELDS_FAILURE = 'PROJECT_ON_BOARD_APICALL_TO_ADD_FIELDS_FAILURE';
export const PROJECT_ON_BOARD_APICALL_TO_ADD_FIELDS_DISMISS_ERROR = 'PROJECT_ON_BOARD_APICALL_TO_ADD_FIELDS_DISMISS_ERROR';
export const PROJECT_ON_BOARD_CREATE_COLLECTION_WITH_XANO_BEGIN = 'PROJECT_ON_BOARD_CREATE_COLLECTION_WITH_XANO_BEGIN';
export const PROJECT_ON_BOARD_CREATE_COLLECTION_WITH_XANO_SUCCESS = 'PROJECT_ON_BOARD_CREATE_COLLECTION_WITH_XANO_SUCCESS';
export const PROJECT_ON_BOARD_CREATE_COLLECTION_WITH_XANO_FAILURE = 'PROJECT_ON_BOARD_CREATE_COLLECTION_WITH_XANO_FAILURE';
export const PROJECT_ON_BOARD_CREATE_COLLECTION_WITH_XANO_DISMISS_ERROR = 'PROJECT_ON_BOARD_CREATE_COLLECTION_WITH_XANO_DISMISS_ERROR';
